/* Offre « 2e parka a -20 % » : pop-up apres ajout + bandeau du tiroir panier.
   Voir le commentaire en tete de snippets/ivelano-panier.liquid.

   v23 (27/10/2026) : remplace l'offre Duo Hiver (adulte + enfant).
   Doit refleter la remise automatique admin « 2e parka : -20 % »
   (Achetez X obtenez Y, non cumulable) : 1 article de la collection
   « Eligibles offre quantite » achete = 1 autre article de la meme
   collection a -20 %, une fois par commande. Collection = tout le
   catalogue SAUF les accessoires (types Gants, Cache-cou, Echarpes).
   On applique ici exactement la meme regle. */
(function(){
  if(window.ivDuo) return;

  var OFFRE = {
    titre: '2e parka',                                   /* debut du titre de la remise */
    lien: '/collections/toutes-les-parkas',
    accessoires: ['gants', 'cache-cou', 'écharpes', 'echarpes', 'écharpe', 'echarpe', 'étole', 'etole']
  };
  var POPUP = {
    titre: 'Votre 2e parka à <b>−20 %</b>',
    txt: 'Votre parka est bien dans le panier. Ajoutez-en une deuxième : elle passe à −20 %, la remise s’applique automatiquement au panier.',
    act: [ { href: OFFRE.lien, label: 'Choisir une 2e parka' } ]
  };

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function estAccessoire(type){ return OFFRE.accessoires.indexOf(String(type || '').toLowerCase()) !== -1; }
  function eligible(it){ return !!(it && it.product_id && !estAccessoire(it.product_type)); }
  function compte(p){
    return ((p && p.items) || []).reduce(function(n, it){ return eligible(it) ? n + it.quantity : n; }, 0);
  }
  function applique(p){
    return ((p && p.items) || []).some(function(it){
      return (it.line_level_discount_allocations || []).some(function(x){
        var t = (x.discount_application && x.discount_application.title) || '';
        return t.indexOf(OFFRE.titre) === 0 && x.amount > 0;
      });
    });
  }
  /* Offre atteinte : remise non cumulable, code promo bloque. */
  function active(p){ return applique(p) || compte(p) >= 2; }

  /* ---- bandeau dans le tiroir ---- */
  function bandeau(p){
    if(applique(p)){
      return '<div class="iv-cart__duo is-ok"><p><b>Offre appliquée :</b> −20 % sur votre 2e parka.</p></div>';
    }
    if(compte(p) === 1){
      return '<div class="iv-cart__duo"><p><b>Offre 2e parka :</b> ajoutez-en une deuxième, elle passe à −20 %. '
           + '<a href="' + OFFRE.lien + '">Voir les parkas</a></p></div>';
    }
    return '';
  }

  /* ---- pop-up ---- */
  function pop(){ return document.getElementById('iv-duo'); }
  function ouvert(){ var p = pop(); return !!(p && p.classList.contains('is-on')); }
  function montrer(){
    var p = pop(); if(!p) return;
    var sur = p.querySelector('.iv-duo__sur');
    if(sur) sur.textContent = 'Offre 2e parka';
    p.querySelector('[data-iv-duo-titre]').innerHTML = POPUP.titre;
    p.querySelector('[data-iv-duo-txt]').textContent = POPUP.txt;
    p.querySelector('[data-iv-duo-act]').innerHTML = POPUP.act.map(function(a){
      return '<a class="iv-btn iv-btn--full' + (a.ghost ? ' iv-btn--ghost' : '') + '" href="' + esc(a.href) + '"><span>' + esc(a.label) + '</span></a>';
    }).join('');
    p.hidden = false;
    p.setAttribute('aria-hidden','false');
    void p.offsetWidth;
    p.classList.add('is-on');
    var premier = p.querySelector('.iv-duo__act a');
    if(premier) premier.focus();
  }
  function cacher(){
    var p = pop();
    if(!p || !p.classList.contains('is-on')) return;
    p.classList.remove('is-on');
    p.setAttribute('aria-hidden','true');
    window.setTimeout(function(){ if(!p.classList.contains('is-on')) p.hidden = true; }, 400);
    var f = document.querySelector('#iv-cart.is-on .iv-cart__x');
    if(f) f.focus();
  }
  document.addEventListener('click', function(e){
    if(e.target.closest && e.target.closest('#iv-duo [data-iv-duo-close]')) cacher();
  });

  /* Apres un ajout reussi d'une parka, s'il n'y en a qu'une au panier :
     propose la 2e a -20 %, une fois par session. Rien pour un accessoire. */
  function proposer(ajout, panier){
    var lst = (ajout && ajout.items) ? ajout.items : [ajout];
    if(!panier || !lst.some(eligible) || compte(panier) !== 1) return;
    try{
      if(sessionStorage.getItem('iv-2e-parka-vu')) return;
      sessionStorage.setItem('iv-2e-parka-vu', '1');
    }catch(e){}
    window.setTimeout(montrer, 450);
  }

  /* Le message « Code non cumulable avec l'offre Duo Hiver » est ecrit en
     dur dans assets/ivelano-panier.js : on le renomme a l'affichage. */
  function renommer(){
    var m = document.querySelector('#iv-cart .iv-cart__code.is-off .iv-cart__code-msg');
    if(m && m.textContent.indexOf('Duo Hiver') > -1) m.textContent = 'Code non cumulable avec l’offre 2e parka à −20 %.';
  }
  function surveiller(){
    var t = document.getElementById('iv-cart');
    if(!t || !('MutationObserver' in window)) return;
    new MutationObserver(renommer).observe(t, { childList: true, subtree: true });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', surveiller);
  else surveiller();

  window.ivDuo = {
    charger: function(){ return Promise.resolve(true); },
    pret: function(){ return true; },
    active: active,
    bandeau: bandeau,
    proposer: proposer,
    ouvert: ouvert,
    cacher: cacher
  };
})();
